/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Insert_SpeakerInputs */

const en_shortcut_keys_desc_insert_speaker = /** @type {(inputs: Shortcut_Keys_Desc_Insert_SpeakerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open the Insert Speaker Name window`)
};

const fr_shortcut_keys_desc_insert_speaker = /** @type {(inputs: Shortcut_Keys_Desc_Insert_SpeakerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ouvrir la fenetre Inserer un nom de locuteur`)
};

const de_shortcut_keys_desc_insert_speaker = /** @type {(inputs: Shortcut_Keys_Desc_Insert_SpeakerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Öffnen Sie das Fenster „Lautsprechernamen einfügen“.`)
};

const it_shortcut_keys_desc_insert_speaker = /** @type {(inputs: Shortcut_Keys_Desc_Insert_SpeakerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aprire la finestra Inserisci nome relatore`)
};

const ru_shortcut_keys_desc_insert_speaker = /** @type {(inputs: Shortcut_Keys_Desc_Insert_SpeakerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Откройте окно «Вставить имя докладчика».`)
};

const es_shortcut_keys_desc_insert_speaker = /** @type {(inputs: Shortcut_Keys_Desc_Insert_SpeakerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abra la ventana Insertar nombre del orador`)
};

const zh_cn2_shortcut_keys_desc_insert_speaker = /** @type {(inputs: Shortcut_Keys_Desc_Insert_SpeakerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打开“插入发言人姓名”窗口`)
};

const ja_shortcut_keys_desc_insert_speaker = /** @type {(inputs: Shortcut_Keys_Desc_Insert_SpeakerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スピーカー名の挿入ウィンドウを開く`)
};

const hi_shortcut_keys_desc_insert_speaker = /** @type {(inputs: Shortcut_Keys_Desc_Insert_SpeakerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्पीकर का नाम डालें विंडो खोलें`)
};

const pt_pt2_shortcut_keys_desc_insert_speaker = /** @type {(inputs: Shortcut_Keys_Desc_Insert_SpeakerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abra a janela Inserir Nome do Orador`)
};

/**
* | output |
* | --- |
* | "Open the Insert Speaker Name window" |
*
* @param {Shortcut_Keys_Desc_Insert_SpeakerInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_insert_speaker = /** @type {((inputs?: Shortcut_Keys_Desc_Insert_SpeakerInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Insert_SpeakerInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_desc_insert_speaker(inputs)
	if (locale === "de") return de_shortcut_keys_desc_insert_speaker(inputs)
	if (locale === "it") return it_shortcut_keys_desc_insert_speaker(inputs)
	if (locale === "ru") return ru_shortcut_keys_desc_insert_speaker(inputs)
	if (locale === "es") return es_shortcut_keys_desc_insert_speaker(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_desc_insert_speaker(inputs)
	if (locale === "ja") return ja_shortcut_keys_desc_insert_speaker(inputs)
	if (locale === "hi") return hi_shortcut_keys_desc_insert_speaker(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_desc_insert_speaker(inputs)
	return en_shortcut_keys_desc_insert_speaker(inputs)
});